import { palette } from './palette';

export const MuiMultiSectionDigitalClockSectionStyles = {
  MuiMultiSectionDigitalClockSection: {
    styleOverrides: {
      root: {
        '& .MuiMultiSectionDigitalClockSection-item.Mui-selected': {
          backgroundColor: palette?.primary,
          color: palette?.text?.primaryInverted,
        },
      },
    },
  },
};

export const MuiClockStyles = {
  MuiClock: {
    styleOverrides: {
      amButton: {
        backgroundColor: 'black',
        color: 'white',
        '&.Mui-selected': {
          backgroundColor: 'orange',
          color: 'black',
        },
      },
      pmButton: {
        backgroundColor: 'black',
        color: 'white',
        '&.Mui-selected': {
          backgroundColor: 'orange',
          color: 'black',
        },
      },
    },
  },
};
